// extracted by mini-css-extract-plugin
module.exports = {"main_page":"TRViewFacts_main_page__32V7y","main_header":"TRViewFacts_main_header__1K8qf","content":"TRViewFacts_content__2SibO"};